import { buildDays } from "../History";
import { tickedSlots } from "../../sync/doc";

/**
 * What the paper face prints, as data: one row per day, its date label, and
 * whether each column is done. The printed grid (`Paper`) and the shared PDF
 * (`pdf.js`) both read it, so the two cannot disagree about which days appear
 * or how a date is written.
 */
export function sheetRows(props) {
  const { slots, ticks, dateFormat, weekdayFormat, showWeekdays } = props;
  const displayFormat = showWeekdays ? `${dateFormat} (${weekdayFormat})` : dateFormat;
  return buildDays(props).map((day) => {
    const checked = tickedSlots(ticks, day);
    return {
      key: day.valueOf(),
      label: day.format(displayFormat),
      done: slots.map((slot) => checked.includes(slot.id)),
    };
  });
}
